<template>
  <div>
    <right-panel :datas="connects" @onClose="onCloseForm" ref="right-panel-add">
      <div slot="header">
        <translate>Add Database</translate>
      </div>
      <div slot="content" class="wrapper-padding">
        <el-form :model="addForm" :rules="rules" ref="addForm" label-width="120px" class="add-form">
          <el-form-item :label="attrText.resourceName" prop="name">
            <el-input v-model.trim="addForm.name" :placeholder="attrText.resourceName"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.type" prop="os">
            <el-select v-model="addForm.os" @change="selectDefault">
              <el-option label="MySQL" value="mysql"></el-option>
              <el-option label="SQL Server" value="mssql"></el-option>
              <el-option label="PostgreSQL" value="postgresql"></el-option>
              <el-option label="Oracle" value="oracle"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="attrText.ipAddress" prop="ipAddress">
            <el-input v-model.trim="addForm.ipAddress" :placeholder="attrText.defaultIpText"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.port" prop="port">
            <el-input v-model.trim="addForm.port"></el-input>
          </el-form-item>
          <el-form-item v-if="addForm.os === 'oracle'" :label="attrText.connectIdentifierType" prop="serviceNameType">
            <el-select v-model="addForm.serviceNameType">
              <el-option label="Service Name" value="service_name"></el-option>
              <el-option label="SID" value="sid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="addForm.os === 'oracle'" :label="attrText.connectIdentifier" prop="serviceName">
            <el-input v-model.trim="addForm.serviceName" :placeholder="attrText.connectIdentifier"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.databaseName" prop="databaseName">
            <el-input v-model.trim="addForm.databaseName" :placeholder="attrText.databaseName"></el-input>
            <p v-if="supportMutipleDatabase"><translate>Multiple database with semicolons ‘;’ ‘</translate><translate style="font-size: 24px; vertical-align: middle; vertical-align: middle; vertical-align: -webkit-baseline-middle;">*</translate><translate>’ indicates authorization all the database</translate></p>
          </el-form-item>
          <el-form-item :label="attrText.username" prop="username">
            <el-input v-model.trim="addForm.username" :placeholder="attrText.username"></el-input>
          </el-form-item>
          <el-form-item :label="attrText.password" prop="password">
            <el-input v-model="addForm.password" :placeholder="attrText.password" type="password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="onSubmitAddForm()" :disabled="btnDisabled">
          <translate>Save</translate>
        </el-button>
        <el-button @click="onCloseForm()">
          <translate>Cancel</translate>
        </el-button>
      </div>
    </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'ClusterAddDatabase',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        btnDisabled: false,
        supportMutipleDatabase: false,
        addForm: {
          name: '',
          instanceId: '',
          ipAddress: '',
          os: 'mysql',
          username: '',
          port: '3306',
          databaseName: '',
          serviceName: '',
          serviceNameType: 'service_name',
          password: ''
        },
        rules: {
          name: [
            {required: true, message: this.$gettext('Please input the resource name'), trigger: 'change'}
          ],
          ipAddress: [
            {required: true, message: this.$gettext('Please input the ip/link address'), trigger: 'change'}
          ],
          os: [
            {required: true, message: this.$gettext('Please input the userName'), trigger: 'change'}
          ],
          username: [
            {required: true, message: this.$gettext('Please input the username'), trigger: 'change'}
          ],
          databaseName: [
            {validator: this.checkDatabase, trigger: 'change, blur'}
          ],
          serviceNameType: [
            {required: true, message: this.$gettext('Please select the connection identifier type'), trigger: 'change'}
          ],
          serviceName: [
            {required: true, message: this.$gettext('Please input the Service Name / SID'), trigger: 'change'}
          ],
          port: [
            {required: true, message: this.$gettext('Please input the port'), trigger: 'change'}
          ],
          password: [
            {required: true, message: this.$gettext('Please input the password'), trigger: 'change'}
          ]
        }
      }
    },
    computed: {
      attrText () {
        return this.getTransitionText()
      }
    },
    methods: {
      getTransitionText () {
        return {
          resourceName: this.$gettext('Resource name'),
          ipAddress: this.$gettext('IP/Connection Address'),
          defaultIpText: this.$gettext('IP or connection string'),
          type: this.$gettext('Type'),
          username: this.$gettext('Username'),
          port: this.$gettext('Port'),
          password: this.$gettext('Password'),
          databaseName: this.$gettext('Database Name'),
          connectIdentifier: this.$gettext('Service Name / SID'),
          connectIdentifierType: this.$gettext('Connection identifier type')
        }
      },
      checkDatabase (rule, value, callback) {
        let val = value.trim()
        if (val) {
          if (this.supportMutipleDatabase) {
            callback()
          } else {
            if (val.indexOf('*') >= 0 || val.indexOf(';') >= 0) {
              callback(new Error(this.$gettext('Database name format is incorrect')))
            } else {
              callback()
            }
          }
        } else {
          callback(new Error(this.$gettext('Please input the databaseName')))
        }
      },
      selectDefault (val) {
        if (val === 'mysql') {
          this.addForm.port = '3306'
        } else if (val === 'postgresql') {
          this.addForm.port = '5432'
        } else if (val === 'oracle') {
          this.addForm.port = '1521'
          this.addForm.serviceNameType = 'service_name'
        } else {
          this.addForm.port = '1433'
        }
      },
      // 确定添加资源
      onSubmitAddForm () {
        this.$refs['addForm'].validate((valid) => {
          if (valid) {
            let options = this.addForm
            let params = {
              data: {
                network_id: Number(this.$route.params.id),
                resources: [{
                  name: options.name,
                  ip_address: options.ipAddress,
                  os: options.os,
                  username: [options.username],
                  password: options.password,
                  port: Number(options.port),
                  databases: [],
                  service_name: options.os === 'oracle' ? options.serviceName : null,
                  service_name_type: options.os === 'oracle' ? options.serviceNameType : null
                }]
              }
            }
            options.databaseName.split(';').forEach(el => {
              if (el && el.trim()) {
                params.data.resources[0].databases.push(el.trim())
              }
            })
            this.btnDisabled = true
            this.$store.dispatch(STORE_CONST.CLUSTER.ADD_RESOURCE, params).then(res => {
              this.$notify({
                message: this.$gettext('Add Successfully!'),
                type: 'success'
              })
              this.$refs['right-panel-add'].onClose()
              this.btnDisabled = false
              this.$emit('callback')
              this.onCloseForm()
            }).catch(err => {
              this.btnDisabled = false
              if (err.code === 'ResourceExceeded') {
                this.$notify({
                  type: 'error',
                  message: this.$gettext('ResourceExceeded.')
                })
              }
            })
          }
        })
      },
      // 关闭添加成员
      onCloseForm () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
              this.supportMutipleDatabase = this.items.supportMutipleDatabase
            }, 300)
          } else {
            this.connects = this.items
            this.supportMutipleDatabase = this.items.supportMutipleDatabase
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// cluster-add-database.vue?4d47b94c